import Scaling from '../../Scaling.js';
import BaseWeapon from '../base.js';

const CrescentPike = (props) => {
  
  return BaseWeapon({
    ...props,
    type: 'polearm',
    name: 'Crescent Pike',
    lvl1Atk: 44,
    lvl1Sub: 0.075,
    subType: 'damageBonus.physical',
    PersistentResolve(result, context) {
      /**
       * effect: 'After picking up an Elemental Orb/Particle, Normal and 
       * Charged Attacks deal an additional [20%] ATK as DMG for 5s.'
       */
      if(this.IsSelf(result)) {
      }
      return result;
    }
  });
};

export default CrescentPike;